import { __ } from "@wordpress/i18n"
import { 
  useBlockProps, 
  InspectorControls,
  RichText,
  InnerBlocks
} from "@wordpress/block-editor"
import { 
  PanelBody,
  Notice,
  Button
} from "@wordpress/components"
import { useState } from "@wordpress/element"

// Import testimonials component and controls
import TestimonialsCarousel from '../../components/TestimonialsCarousel'
import { TestimonialControls, getTestimonialProps } from '../../components/TestimonialsCarousel/controls'

export default function Edit({ attributes, setAttributes }) {
  const blockProps = useBlockProps({
    className: "emergency-response"
  })

  // Get testimonial props from attributes
  const testimonialProps = getTestimonialProps(attributes)

  // Default content
  const defaultHeading = attributes.mainHeading || '<strong>PuroClean</strong> responds with urgency and sensitivity <strong>24 hours a day, 7 days a week</strong>, to help you with your property damage needs.'
  const defaultLinkText = attributes.linkText || 'Find your Local PuroClean office'

  // Default template for new blocks - only used when no content exists
  const template = [
    ['core/paragraph', { 
      content: '<strong>PuroClean</strong>, a leader in <strong>property emergency services</strong>, helps families and businesses overcome the devastating setbacks caused by <strong>water</strong>, <strong>fire</strong>, <strong>mold</strong>, and other conditions resulting in <strong>property damage</strong>. Each of our independently owned and operated franchises pledges to do whatever it takes to <strong>respond</strong>, <strong>restore</strong>, and <strong>rescue</strong> properties in all of the communities we serve.',
      placeholder: 'Enter paragraph content...'
    }]
  ]

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Emergency Response Settings', 'puroclean')} initialOpen={true}>
          <Notice status="info" isDismissible={false}>
            <p>
              <strong>Content:</strong> Click on any text to edit directly<br />
              <strong>Paragraphs:</strong> Press Enter twice to create new paragraphs<br />
              <strong>Reorder:</strong> Drag paragraphs to reorder them<br />
              <strong>Testimonials:</strong> Configure testimonials from reviews CTP below<br />
              <strong>Preview:</strong> Shows exactly how it appears on frontend
            </p>
          </Notice>
        </PanelBody>

        {/* Testimonials Controls */}
        <TestimonialControls 
          attributes={attributes} 
          setAttributes={setAttributes} 
        />
      </InspectorControls>

      <div {...blockProps}>
        <div className="py-16 bg-gray-50">
          <div className="max-w-content mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-10 gap-24 items-start">
              
              {/* Left Column - Main Content (60%) */}
              <div className="lg:col-span-6">
                {/* Main Heading */}
                <RichText
                  tagName="h2"
                  placeholder={__('Main heading...', 'puroclean')}
                  value={defaultHeading}
                  onChange={(value) => setAttributes({ mainHeading: value })}
                  allowedFormats={['core/bold', 'core/italic']}
                  className="text-3xl font-bold mb-6 leading-tight"
                />

                {/* Main Content - Individual Paragraph Blocks */}
                <div className="space-y-4 text-base leading-relaxed">
                  <InnerBlocks
                    allowedBlocks={['core/paragraph']}
                    template={template}
                    templateLock={false}
                    renderAppender={InnerBlocks.ButtonBlockAppender}
                  />
                </div>

                {/* Link */}
                <div className="mt-6">
                  <a href="#" className="text-primary flex items-center">
                    {/* Linking Arrow Image - placeholder since we can't load actual image in editor */}
                    <div className="w-5 h-5 mr-2 bg-red-600 flex items-center justify-center rounded-sm">
                      <span className="text-white text-xs">→</span>
                    </div>
                    <RichText
                      tagName="span"
                      placeholder={__('Link text...', 'puroclean')}
                      value={defaultLinkText}
                      onChange={(value) => setAttributes({ linkText: value })}
                      allowedFormats={['core/bold', 'core/italic']}
                      className="font-semibold underline"
                    />
                  </a>
                </div>
              </div>
              
              {/* Right Column - Testimonials Component (40%) */}
              <div className="lg:col-span-4">
                <div className="relative">                  
                  {/* Testimonials Carousel Component */}
                  <TestimonialsCarousel 
                    {...testimonialProps}
                    className="emergency-testimonials"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
} 